import { useDispatch } from 'react-redux'
import React, { useState } from 'react'
import * as rest from '../../../services'
import { showErrorToast, showSuccessToast } from '../../../state/toasts'
import * as ReactBootstrap from 'react-bootstrap'
import * as components from '../../../components'

export const SendDeliveryBySMS = ({ ticket }) => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const send = () => {
    setLoading(true)
    new rest.DeliveryService(ticket.delivery.url)
      .send_delivery_details_by_sms()
      .then(() => {
        setLoading(false)
        dispatch(showSuccessToast('Sent Delivery Details By SMS'))
      })
      .catch((error) => {
        setLoading(false)
        dispatch(showErrorToast('Could not Send Delivery Details By SMS'))
      })
  }
  return (
    <ReactBootstrap.Dropdown.Item
      onClick={() => send()}
      block
      variant="outline-secondary"
    >
      {loading ? <components.Loading /> : '  Send Delivery Details By SMS'}
    </ReactBootstrap.Dropdown.Item>
  )
}
